import React from 'react';
import _ from 'lodash';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import * as Convert from '../../utils/convert';
import { fieldFormat } from '../../utils/helper';
import PropTypes from 'prop-types';

/**
 * Edit EditDateRange cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export function EditDateRangeCell({ getColumns }) {
  class EditDateRangeCell extends React.Component {
    timeout = null;

    constructor(props) {
      super(props);

      const { field, dataItem } = props;
      const dataValue = _.get(dataItem, field.split('.'));

      this.state = {
        value: dataValue,
      }
    }

    handleChange = (e) => {
      const { field, dataItem, onChange } = this.props;

      this.setState({ value: e.target.value });

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: e.syntheticEvent,
          value: this.state.value
        });

        this.timeout = null;
      }, 1000);
    }

    // componentDidUpdate(prevProps, prevState) {
    //   const { field, dataItem } = this.props;
    //   const dataValue = _.get(dataItem, field.split('.'));
    //   const prevDataValue = _.get(prevProps.dataItem, prevProps.field.split('.'));
    //   if (prevDataValue !== dataValue) {
    //     this.setState({ value: dataValue });
    //   }
    // }

    render() {
      const { dataItem, field } = this.props;
      const column = getColumns().find(item => item.field === field);
      const format = this.props.format ? fieldFormat(this.props.format) : "dd.MM.y";
      const dataValue = this.state.value;
      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;
      const td = (
        <td colSpan={this.props.colSpan}
          className={className}
          style={this.props.style}
          role="gridcell"
          aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
          aria-selected={false}
          tabIndex="0">
          {((dataItem.inEdit === true || dataItem.inEdit === this.props.field) && column.editable !== false) ? (
            <DateRangePicker
              onChange={this.handleChange}
              value={dataValue}
              format={format}
            />
          ) : (
            `${Convert.dateToStr(dataValue?.start, format)}-${Convert.dateToStr(dataValue?.end, format)}`
          )}
        </td>
      );
      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }

  EditDateRangeCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func
  }

  return EditDateRangeCell
}